module.exports = __webpack_public_path__ + "static/media/maggi.a7bab406.jpg";